goog.provide("shadow.js.shim.module$date_fns$locale$hr$default");
shadow.js.shim.module$date_fns$locale$hr$default = esm_import$date_fns$locale$hr.default;
